import {
    Avatar,
    Box,
    Button,
    Divider,
    Grid,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Tab,
    Tabs,
    TextField,
    Typography,
    Link,
    ListItemIcon,
    CircularProgress,
    InputLabel,
    MenuItem,
    Select,
    SelectChangeEvent,
    Stack,
    styled,
} from "@mui/material";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import IconButton from "@mui/material/IconButton";
import nodoc from "../../../../Image/nodoc.png";


const top100Films = [
    { title: "The Shawshank Redemption", year: 1994 },
    { title: "The Godfather", year: 1972 },
    { title: "The Godfather: Part II", year: 1974 },
    { title: "The Dark Knight", year: 2008 },
    { title: "12 Angry Men", year: 1957 },
    { title: "Schindler's List", year: 1993 },
    { title: "Pulp Fiction", year: 1994 },
];

interface Film {
    title: string;
    year: number;
}

const sleep = (ms: number): Promise<void> =>
    new Promise((resolve) => setTimeout(resolve, ms));

const ErroPagerPDF = () => {
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState<Film[]>([]);
    const [loadingAutocomplete, setLoadingAutocomplete] = useState(false);

    const [scale, setScale] = useState(0.6);

    const viewerRef = useRef(null);

    const hiddenFileInputCreatePDF = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (!open) {
            setOptions([]);
            return;
        }

        setLoadingAutocomplete(true);
        sleep(1000).then(() => {
            setLoadingAutocomplete(false);
            setOptions(top100Films);
        });
    }, [open]);

    useEffect(() => {
        const container: any = viewerRef.current;
        if (container) {
            const handleResize = () => {
                const newScale = container.clientWidth / 1012; // 612 is the default width of the page in points
                setScale(newScale);
            };
            handleResize();
            window.addEventListener("resize", handleResize);
            return () => {
                window.removeEventListener("resize", handleResize);
            };
        }
    }, []);


    const getBase64File = (file: File): Promise<string> => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });
    };

    const uploadPDF = async (e: React.ChangeEvent<HTMLInputElement>) => {
        try {
            const files = e.target.files;
            if (!files || files.length === 0) return;

            let fileArray = Array.from(files);

            // Limit to 5 files
            if (fileArray.length > 5) {
                Swal.fire({
                    title: "เลือกไฟล์มากเกินไป",
                    text: "สามารถเลือกได้สูงสุด 5 ไฟล์เท่านั้น",
                    icon: "warning",
                });
                return;
            }

            // Validate file type and size
            fileArray = fileArray.filter((file) => {
                if (file.type !== "application/pdf") {
                    Swal.fire({
                        title: "ไฟล์ไม่ถูกต้อง",
                        text: `ไฟล์ "${file.name}" ไม่ใช่ PDF`,
                        icon: "error",
                    });
                    return false;
                }

                if (file.size > 2 * 1024 * 1024) {
                    Swal.fire({
                        title: "ไฟล์ใหญ่เกินไป",
                        text: `ไฟล์ "${file.name}" มีขนาดเกิน 2MB`,
                        icon: "error",
                    });
                    return false;
                }

                return true;
            });

            if (fileArray.length === 0) return;

            // Convert files to base64
            const base64Files = await Promise.all(fileArray.map(getBase64File));
            setSelectedFiles(fileArray);
            // console.log("Uploaded PDFs:", base64Files);
        } catch (error) {
            console.error("File upload error:", error);
        } finally {
            e.target.value = ""; // Reset input field
        }
    };



    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column", // Set to column
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
            }}
        >
            <img
                src={nodoc}
                alt="icon"
                style={{ width: 200, height: 180 }}
            />
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
            >
                <Typography sx={{ mt: 2 }}>ไม่มีข้อมูลเอกสาร</Typography>
            </Box>


        </Box>
    );
};

export default ErroPagerPDF;
